import React from 'react';
import { Modal } from 'reactstrap';

const DeleteQuestionModal = ({
  cancelQuestionDelete,
  modalToggle,
  confirmDeleteQuestion,
}) => {
  return (
    <Modal isOpen={modalToggle} toggle={cancelQuestionDelete}>
      <div className="modal-header">
        <h5 className="modal-title">Delete Question </h5>
        <span
          role="presentation"
          onClick={cancelQuestionDelete}
          className="close-delete-popup cursor-pointer"
        >
          X
        </span>
      </div>
      <div className="modal-body">
        <p>
          Are you sure you want to delete this Question? This action will also
          delete reports related to this Question.
        </p>
        <p>This action is not recoverable.</p>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={cancelQuestionDelete}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={confirmDeleteQuestion}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteQuestionModal;



// WEBPACK FOOTER //
// ./src/components/questions/modals/deleteQuestion.js